export default function pluralCheck(count, single, plural) {
  if (Array.isArray(count)) {
    return count.length === 1 ? single : plural
  }
  return count === 1 ? single : plural
}
